<template>
  <li class="t-toc-item">
    <div
      class="t-toc-entry"
      @keydown.61.prevent="toggle(true)"
      @keydown.173.prevent="toggle(false)"
    >
      <!-- first in the DOM for tab order, reordered in flexbox -->
      <AppLink :pageNum="entry['page-number']" class="t-toc-link" tabindex="0">
        <span class="t-toc-text" v-html="titleHtml" />
        &hellip;&nbsp;<span class="t-toc-page">{{
          entry['logical-page']
        }}</span>
      </AppLink>

      <!-- second in the DOM for tab order, reordered in flexbox -->
      <button
        v-bind="
          hasChildren
            ? {
                'aria-haspopup': 'tree',
                'aria-controls': $id('subtree'),
                'aria-expanded': `${!!open}`,
                'aria-label': `Expand subtree for section: ${entry.title}`,
                tabindex: '0',
              }
            : {
                'aria-hidden': 'true',
                disabled: true,
                tabindex: '-1',
              }
        "
        class="t-toc-toggle"
        @click="toggle()"
        v-visible="hasChildren"
      >
        {{ open ? '▼' : '▶' }}
      </button>
    </div>
    <Toc
      v-if="hasChildren"
      :id="$id('subtree')"
      :level="level + 1"
      :model="entry.children"
      :open="open"
    />
  </li>
</template>

<style scoped lang="scss">
@import './common';

.t-toc-item {
  margin: 0;
  padding: 0;
  font-size: $tocTextSize;
  color: $tocTextColor;

  .t-toc-item & {
    margin-left: $tocLevelIndent;
    border-left: 1px solid $tocBorderColor;
  }
}

.t-toc-entry {
  display: flex;
  align-items: flex-start;
  padding: $tocPadding 0;

  .t-toc-toggle {
    order: 1;
    flex: 0 0 px(1.5rem);
    align-self: flex-start;
    margin: 0;
    padding: 0;
    border: 0;
    background-color: transparent;
    font-weight: bold;
    color: $tocHeadTextColor;
    position: relative;
  }

  .t-toc-link {
    order: 2;
    display: block;
    align-self: flex-start;
    cursor: pointer;
    text-decoration: none;
    font-weight: $tocFontWeight;
    position: relative;
    &,
    &:visited {
      color: $tocLinkColor;
    }
    &:active {
      background-color: $tocActiveBackgroundColor;
      color: $tocLinkColorActive;
    }
  }

  .t-toc-toggle,
  .t-toc-link {
    &:focus-visible {
      @include focus-indicator($defaultFocusColor);
    }
  }

  .has-hover &:hover {
    background-color: $tocHoverBackgroundColor;
    .t-toc-toggle,
    .t-toc-link {
      color: $tocLinkColorHover;
    }
  }
}

.t-toc-page {
  color: $tocPageColor;
}
</style>

<script>
import AppLink from './AppLink.vue'
import BaseMixin from './BaseMixin.vue'
import Toc from './Toc.vue'
import {simplifyTocHtml} from '../lib/html'

export default {
  name: 'TocEntry',

  mixins: [BaseMixin],

  props: {
    entry: {
      type: Object,
      required: true,
    },
    level: {
      type: Number,
      required: true,
    },
  },

  data() {
    return {
      open: false,
    }
  },

  computed: {
    hasChildren() {
      return !!this.entry['has-children']
    },

    titleHtml() {
      return simplifyTocHtml(this.entry.title)
    },
  },

  methods: {
    toggle(state = !this.open) {
      this.open = state && this.hasChildren
    },
  },

  components: {
    AppLink,
    Toc,
  },
}
</script>
